<div class="top-bar" [class.top-bar-report-selected]="isReportSelected" *ngIf="!isReportExpanded">

    <app-widget-textbox class="filter-box" [model]="filter" (modelChange)="filter=$event;filterReports()"
        placeholder="{{ 'Search' | i18next }}" textboxWidth="300px"></app-widget-textbox>
    <i class="fal fa-search"></i>
    <mat-radio-group class="report-type-radio-group report-type" [(ngModel)]="customReports" (ngModelChange)="filterReports()">
        <mat-radio-button [value]="false" class="redRadio"> <span class="reports-radio-label">{{ 'dashboard:Standard Reports' | i18next }}</span></mat-radio-button>
        <mat-radio-button [value]="true" class="redRadio"> <span class="reports-radio-label">{{ 'dashboard:Custom Reports' | i18next }}</span></mat-radio-button>
    </mat-radio-group>
    <ng-select *ngIf="isMultiSource" [items]="reportSources" bindLabel="text" bindValue="key" class="reports-type-select" [searchable]="false" [(ngModel)]="reportSourcesSelectedIndex"
               (change)="filterReports()">
    </ng-select>
    <ng-select [items]="reportCategories" bindLabel="category" bindValue="id" [(ngModel)]="categoryId" [disabled]="!customReports" class="category-select" placeholder="{{ 'Select'| i18next }}"
               [class.active]="categoriesOpened" (change)="filterReports()" (focus)="categoriesOpened=true" (blur)="categoriesOpened=false" [searchable]="false">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
            {{item.category}}
        </ng-template>
    </ng-select>
    <button mat-flat-button matStepperNext (click)=showCategories()  [disabled]="!customReports" [ngClass]="['secondary-button', 'category-button']">
      {{ 'dashboard:Categories' | i18next }}
    </button>
    <button class="subscription-info" (click)="showSubscriptionInfo()" [class.active]="subscriptionInfoActive"><i class="fal fa-info-circle"></i></button>
  </div>
<div class="reports-container" [class.reports-container-full-height]="isReportExpanded">
    <div class="reports-data thin-scroll" *ngIf="!isReportSelected">
        <table [class.table-shrinked]="isReportSelected">
            <thead>
                <tr>
                    <th (click)="sort('shortDescription')" class="col-name">{{ 'dashboard:Report Name' | i18next }}
                        <i class="fad fa-sort" [class.fa-sort-down]="order.by=='shortDescription' && order.desc" [class.fa-sort-up]="order.by == 'shortDescription' && !order.desc"></i>
                    </th>
                    <th *ngIf="!customReports"  (click)="sort('longDescription')">{{ 'dashboard:Description' | i18next}}
                        <i class="fad fa-sort" [class.fa-sort-down]="order.by=='longDescription' && order.desc" [class.fa-sort-up]="order.by == 'longDescription' && !order.desc"></i>
                    </th>
                    <th *ngIf="customReports" (click)="sort('userDescription')">{{ 'dashboard:Custom Description' | i18next }}
                        <i class="fad fa-sort" [class.fa-sort-down]="order.by=='userDescription' && order.desc" [class.fa-sort-up]="order.by == 'userDescription' && !order.desc"></i>
                    </th>
                    <th (click)="sort('category')" *ngIf="customReports" class="col-category">{{ 'dashboard:Category' | i18next }}
                        <i class="fad fa-sort" [class.fa-sort-down]="order.by=='category' && order.desc" [class.fa-sort-up]="order.by == 'category' && !order.desc"></i>
                    </th>
                    <th (click)="sort('standReportName')" *ngIf="customReports" class="col-based-on">{{ 'dashboard:Based on' | i18next }}
                        <i class="fad fa-sort" [class.fa-sort-down]="order.by=='standReportName' && order.desc" [class.fa-sort-up]="order.by == 'standReportName' && !order.desc"></i>
                    </th>
                    <th *ngIf="customReports" class="col-buttons"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let report of reportsFiltered; index as i">
                    <td>
                      <div class="tbl-cell" (click)="select(report)" [class.tbl-cell-selected]="report.id == reportId && report.subReportId == subReportId">
                            <a (keyup.enter)="select(report)" tabindex="0">
                              <span *ngIf="report.isNonStandardReport">[Special]</span> {{report.shortDescription}}
                            </a>
                      </div>
                    </td>
                    <td>
                        <!--<div class="tbl-cell" *ngIf="!customReports" [matTooltip]="report.longDescription" matTooltipClass="tooltip-large">
                            <span>{{report.longDescription}}</span>
                        </div>-->
                      <div class="tbl-cell" *ngIf="!customReports">
                        <span>{{report.longDescription}}</span>
                      </div>
                      <div class="tbl-cell" *ngIf="customReports && !report.isNonStandardReport">
                        <span>{{report.userDescription}}</span>
                      </div>
                      <div class="tbl-cell" *ngIf="customReports && report.isNonStandardReport">
                        <span>{{ report.userDescription ? report.longDescription : report.userDescription}}</span>
                      </div>
                    </td>
                    <td *ngIf="customReports">
                        <div class="tbl-cell">
                            {{report.category}}
                        </div>
                    </td>
                    <td *ngIf="customReports">
                        <div class="tbl-cell col-based-on">
                          <span *ngIf="!report.isNonStandardReport">{{report.standReportName}}</span>
                        </div>
                    </td>
                    <td *ngIf="customReports">
                        <div class="tbl-cell tbl-cell-buttons">
                            <button (click)="editReport(report)" [disabled]="!canEdit || report.isNonStandardReport"><i [ngClass]="['fal fa-edit', 'edit-icon']" ></i></button>
                            <button (click)="deleteReport(report)"[disabled]="!canEdit || report.hasScheduledReport || report.isNonStandardReport">
                              <i [ngClass]="['fal fa-trash-alt', 'delete-icon']" [matTooltipDisabled]="!report.hasScheduledReport" matTooltipClass="tooltip-font-14"
                                  [matTooltip]=" 'dashboard:Report is used in one or more report subscriptions.' | i18next" ></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div [class.table-shrinked]="isReportSelected" class="container-blank" [class.container-blank-table-empty]="reportsFiltered?.length == 0">
            <div *ngIf="reportsFiltered?.length==0">
                <span>{{ "dashboard:Sorry, we couldn't find any results." | i18next }}</span>
            </div>
        </div>
    </div>
    <div *ngIf="isReportSelected && !isReportExpanded" class="list-reports-container">
        <div class="col-nale">{{ 'dashboard:Report Name' | i18next }}</div>
        <div class="list-reports ">
            <div class="thin-scroll">
                <div *ngFor="let report of reportsFiltered">
                    <!--<div class="tbl-cell" (click)="select(report)" [matTooltip]="report.shortDescription" [matTooltipShowDelay]="500"
                    matTooltipClass="tooltip-font-14"    [class.tbl-cell-selected]="report.id == reportId && report.subReportId == subReportId">
                        <a (keyup.enter)="select(report)" tabindex="0">{{report.shortDescription}}</a>
                    </div>-->
                  <div class="tbl-cell" id="reportIds-{{ report.id }}-{{ report.subReportId }}" #reportItem (click)="select(report)"
                       [class.tbl-cell-selected]="report.id == reportId && report.subReportId == subReportId">
                        <a (keyup.enter)="select(report)" tabindex="0">{{ report.shortDescription }}</a>
                    </div>
                </div>
                <div class="last-item" [class.container-blank-table-empty]="reportsFiltered?.length==0">
                  <div *ngIf="reportsFiltered?.length == 0">
                    <span>{{ "dashboard:Sorry, we couldn't find any results." | i18next }}</span>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <app-pcc-reports-details *ngIf="isDetailsComponentShown(1)" class="report-details thin-scroll" [reportId]="reportId" [class.report-expanded]="isReportExpanded" [subReportId]="subReportId"
                         (refreshNotifier)="getReports()" (reportModifiedNotifier)="reportModified($event)" (reportExpandedNotifier)="reportExpanded($event)"
                         (reportCloseNotifier)="reportClose($event)" [fromDashboard]="getFromDashboard" (reportLoadedNotifier)="setSelectedReportOnFocus()">
    </app-pcc-reports-details>

        <!--
          Switch to this component when the Web Engage report is selected
        -->
    <app-rule-match-details *ngIf="isDetailsComponentShown(2)" class="report-details thin-scroll" [reportId]="reportId" [class.report-expanded]="isReportExpanded" [subReportId]="subReportId"
                         (refreshNotifier)="getReports()" (reportModifiedNotifier)="reportModified($event)" (reportExpandedNotifier)="reportExpanded($event)"
                         (reportCloseNotifier)="reportClose($event)" [fromDashboard]="getFromDashboard" (reportLoadedNotifier)="setSelectedReportOnFocus()">
    </app-rule-match-details>
</div>
